"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ProgressBarStepList = props => {
  var {
    activeStep,
    steps,
    subtitle,
    detailedStepper,
    stepTitle
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.StepList, {
    activeStep: activeStep,
    steps: steps,
    subtitle: subtitle,
    detailedStepper: detailedStepper,
    stepTitle: stepTitle
  })));
};
var _default = exports.default = ProgressBarStepList;